import React, { useMemo } from 'react'

import { Page, View, Text } from '@react-pdf/renderer'
import styles from '../style'

import TopBanner from '../Components/TopBanner'
import tableStyles from '../Components/ServiceTable/tableStyles'

type IFundingBreakdownPage = {
  rates: {
    name: string
    employeeOnly: string
    employeePlusSpouse: string
    employeePlusChildren: string
    employeePlusFamily: string
  }[]
}

const TableHeader = () => (
  <View style={[
    styles.row,
    {
      marginTop: 0,
      paddingVertical: 4,
      paddingHorizontal: 4,
      backgroundColor: '#6d39d9',
    }
  ]}>
    <Text
      style={[
        styles.descriptionText,
        tableStyles.cellText,
        { width: '20%', fontWeight: 'bold', color: 'white' },
      ]}
    >
      Plan Name
    </Text>
    <Text
      style={[
        styles.descriptionText,
        tableStyles.cellText,
        { width: '20%', fontWeight: 'bold', color: 'white' },
      ]}
    >
      Employee
    </Text>
    <Text
      style={[
        styles.descriptionText,
        tableStyles.cellText,
        { width: '20%', fontWeight: 'bold', color: 'white' },
      ]}
    >
      Employee+Spouse
    </Text>
    <Text
      style={[
        styles.descriptionText,
        tableStyles.cellText,
        { width: '20%', fontWeight: 'bold', color: 'white' },
      ]}
    >
      Employee+Children
    </Text>
    <Text
      style={[
        styles.descriptionText,
        tableStyles.cellText,
        { width: '20%', fontWeight: 'bold', color: 'white' },
      ]}
    >
      Employee+Family
    </Text>
  </View>
)

const RateFormatter = ({ amount, percentage }: { amount: string, percentage: number }) => {
  const amountInDollars = parseFloat(amount.replace(/[^0-9.]/g, ''))
  if (isNaN(amountInDollars)) {
    return (
      <>N/A</>
    )
  }

  return (
    <>
      ${(amountInDollars * (percentage/100)).toFixed(2)}
    </>
  )
}

const FundingBreakdownPage = ({ rates }: IFundingBreakdownPage) => {
  const fundingAllocation = [
    { title: 'Claims Fund', percentage: 60 },
    { title: 'Stoploss Premium', percentage: 30 },
    { title: 'Administrative Fee', percentage: 10 },
  ]

  const ratesGroupedByPage = useMemo(() => {
    const pages = []
    let lastIndex = 0
    while (lastIndex < rates.length) {
      pages.push(rates.slice(lastIndex, lastIndex + 10))
      // Group every 40 records
      lastIndex = lastIndex + 10
    }

    return pages
  }, [rates])

  return (
    <>
      {ratesGroupedByPage.map((pageRates, index) => (
        <Page key={index}>
          <TopBanner title="Funding Allocation" />
          <View style={styles.pageBody}>
            {fundingAllocation.map(({ title, percentage }) => (
              <View
                style={{
                  marginTop: '16px',
                  display: 'flex',
                  width: '100%',
                }}
              >
                <Text style={{ fontSize: 12, marginBottom: 4 }}>
                  { title }
                </Text>
                <TableHeader />
                {pageRates.map((rate, rowIndex) => (
                  <View
                    style={[
                      styles.row,
                      { marginTop: 0, paddingVertical: 4 },
                      { backgroundColor: rowIndex % 2 === 0 ? '#F8F9FA' : 'white' }
                    ]}
                  >
                    <Text
                      style={[
                        { width: '20%' },
                        tableStyles.cellText
                      ]}
                    >
                      { rate.name }
                    </Text>
                    <Text
                      style={[
                        { width: '20%' },
                        tableStyles.cellText
                      ]}
                    >
                      <RateFormatter amount={rate.employeeOnly} percentage={percentage} />
                    </Text>
                    <Text
                      style={[
                        { width: '20%' },
                        tableStyles.cellText
                      ]}
                    >
                      <RateFormatter amount={rate.employeePlusSpouse} percentage={percentage} />
                    </Text>
                    <Text
                      style={[
                        { width: '20%' },
                        tableStyles.cellText
                      ]}
                    >
                      <RateFormatter amount={rate.employeePlusChildren} percentage={percentage} />
                    </Text>
                    <Text
                      style={[
                        { width: '20%' },
                        tableStyles.cellText
                      ]}
                    >
                      <RateFormatter amount={rate.employeePlusFamily} percentage={percentage} />
                    </Text>
                  </View>
                ))}
              </View>
            ))}
            <Text style={{ fontStyle: 'italic', fontSize: 6, marginTop: 4 }}>
              Amounts displayed are illustrative and may vary.
            </Text>
          </View>
        </Page>
      ))}
    </>
  )
}

export default FundingBreakdownPage
